<div class="zn-form" [formGroup]="form">
  <fieldset>
    <div class="row">
      <div class="col-12">
        <div class="form-control-container">
          <label class="form-label" for="MeditionNumbers">
            {{ measurementLabelKey | abpLocalization }}
            <span class="form-label-required">*</span>
          </label>
          <zn-multi-select
            #measurementSelect
            id="MeditionNumbers"
            [optionsLoader]="meditionNumbers"
            [showSearch]="true"
            [deferSelection]="false"
            formControlName="MeditionNumbers"
            [errorEntityKey]="measurementLabelKey"
            [localizationResource]="localizationResource"
            [openUp]="false"
            (selectedChange)="onMeasurementSelectionChange($event)"
          ></zn-multi-select>
        </div>
      </div>
    </div>
  </fieldset>
</div>
